import { useEffect, useState } from "react";
import { config } from "@/config";
import { getIdToken } from "@/lib/firebase";

/** First-login gate: pick your operator handle ONCE, permanent after. Blocks until chosen
 *  (no dismiss) so every message on the desk carries a stable, deliberate identity. */

export function HandleGate() {
  const [needed, setNeeded] = useState(false);
  const [suggested, setSuggested] = useState("");
  const [draft, setDraft] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const token = await getIdToken();
        const r = await fetch(`${config.restUrl}/api/chat?limit=1`, { headers: { Authorization: `Bearer ${token}` } });
        if (!r.ok) return;
        const j = (await r.json()) as { handle?: string | null; handleSet?: boolean };
        if (alive && j.handleSet === false) {
          setSuggested(j.handle ?? "");
          setDraft(j.handle ?? "");
          setNeeded(true);
        }
      } catch { /* offline — don't block the app */ }
    })();
    return () => { alive = false; };
  }, []);

  if (!needed) return null;

  async function save() {
    const handle = draft.trim();
    if (!handle) return;
    setBusy(true);
    setErr(null);
    try {
      const token = await getIdToken();
      const r = await fetch(`${config.restUrl}/api/chat/handle`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}`, "content-type": "application/json" },
        body: JSON.stringify({ handle }),
      });
      const j = (await r.json().catch(() => ({}))) as { handle?: string; error?: string };
      if (!r.ok) throw new Error(j.error ?? `HTTP ${r.status}`);
      window.dispatchEvent(new CustomEvent("ew:handle", { detail: j.handle ?? handle }));
      setNeeded(false);
    } catch (e) {
      setErr(e instanceof Error ? e.message : "could not save handle");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fb-backdrop" style={{ zIndex: 70 }}>
      <div className="fb-modal" onClick={(e) => e.stopPropagation()}>
        <div className="fb-head"><span className="t">CHOOSE YOUR HANDLE</span></div>
        <div className="fb-body">
          <p className="fb-thanks" style={{ marginBottom: 0 }}>
            This is your name on the desk — chat, suggestions, everywhere. Set once, <b>permanent</b>.
            3–20 characters: letters, digits, underscore.
          </p>
          <input
            className="sg-title"
            maxLength={20}
            value={draft}
            placeholder={suggested || "your_handle"}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") void save(); }}
            autoFocus
          />
          {err && <div className="auth-error">{err}</div>}
          <button className="auth-btn primary" disabled={busy || !draft.trim()} onClick={() => void save()}>
            {busy ? "SAVING…" : "LOCK IT IN"}
          </button>
        </div>
      </div>
    </div>
  );
}
